
import PrepaidPurchaseSummary from "@/interfaces/Contracts/PrepaidPurchaseSummary";
import { Vue, Component, Prop } from "vue-property-decorator";
import TableHeader from "@/interfaces/UserInterface/Tables/TableHeaders";

@Component
export default class DetailPrepaidSummaries extends Vue {
  @Prop({ required: true })
  items!: PrepaidPurchaseSummary[];

  tableHeaders: TableHeader[] = [
    { text: "ID", value: "purchaseSummary" },
    { text: "Name", value: "purchaseSummaryName" },
    { text: "Amount", value: "amount" },
    { text: "Sold", value: "sold" },
  ];

  itemSelected(item: PrepaidPurchaseSummary): void {
    this.$emit("detail-prepaid-summaries-summary-selected", item);
  }

  get dataTableItemKey(): string {
    return this.items.find((item) => item.purchaseSummary === "")
      ? "purchaseSummaryName"
      : "purchaseSummary";
  }
}
